var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.995 511.995",
    style: {
      enableBackground: "new 0 0 511.995 511.995"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.508,417.251c-5.701,0-11.402-2.237-15.618-6.733c-8.175-8.627-7.788-22.244,0.839-30.419 l165.217-156.397c4.41-4.173,10.391-6.303,16.393-5.83c6.045,0.452,11.617,3.442,15.338,8.196l64.796,82.953L475.208,101.08 c8.39-8.39,21.986-8.476,30.419-0.086c8.433,8.368,8.476,21.986,0.086,30.419L281.767,356.65 c-4.346,4.389-10.455,6.54-16.543,6.303c-6.174-0.366-11.875-3.356-15.683-8.239l-65.248-83.533L36.265,411.335 C32.135,415.293,26.821,417.251,21.508,417.251z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.482,309.903c-11.896,0-21.513-9.616-21.513-21.513V137.802H318.382 c-11.896,0-21.513-9.638-21.513-21.513s9.616-21.513,21.513-21.513h172.101c11.896,0,21.513,9.638,21.513,21.513V288.39 C511.995,300.265,502.357,309.903,490.482,309.903z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfits);
export default __webpack_public_path__ + "static/media/profits.a6c129a499636ad131e42cff9ca467ee.svg";
export { ForwardRef as ReactComponent };